import { createSlice } from '@reduxjs/toolkit';
import { createAllopathy, getAllopathyDetails, getAllopathys, updateAllopathy } from '.';

const initialState = {
	loading: false,
	list: [],
	details: null,
	total: 0,
};

const allopathys = createSlice({
	name: 'allopathys',
	initialState,
	reducers: {
		resetAllopathys: () => initialState,
		setAllopathysDetails: (state, action) => {
			state.details = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(getAllopathys.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllopathys.fulfilled, (state, action) => {
				state.loading = false;
				const { total, data } = action.payload.response.data.data;
				state.list = data;
				state.total = total;
			})
			.addCase(getAllopathys.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(createAllopathy.pending, (state) => {
				state.loading = true;
			})
			.addCase(createAllopathy.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(createAllopathy.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(updateAllopathy.pending, (state) => {
				state.loading = true;
			})
			.addCase(updateAllopathy.fulfilled, (state) => {
				state.loading = false;
				state.details = null;
			})
			.addCase(updateAllopathy.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getAllopathyDetails.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllopathyDetails.fulfilled, (state, action) => {
				state.loading = false;
				state.details = action.payload.response.data.data;
			})
			.addCase(getAllopathyDetails.rejected, (state) => {
				state.loading = false;
			});
	}
});

export const { resetAllopathys, setAllopathysDetails } = allopathys.actions;

export default allopathys.reducer;